import { z } from 'zod';
import { instrumentSchema } from './instrument';

export const skillLevelSchema = z.object({
  name: z.string(),
});

export type SkillLevelSchema = z.infer<typeof skillLevelSchema>;

export const profileSkillLevelsSchema = z.object({
  instrument: instrumentSchema,
  skillLevel: skillLevelSchema,
});

export type ProfileSkillLevelsSchema = z.infer<typeof profileSkillLevelsSchema>;

export const profileSkillLevelsArraySchema = z.array(profileSkillLevelsSchema);

export type ProfileSkillLevelsArraySchema = z.infer<typeof profileSkillLevelsArraySchema>;

export const profileSkillLevelSchema = z.object({
  instrument: z.string(),
  skillLevel: z.string(),
});

export type ProfileSkillLevelSchema = z.infer<typeof profileSkillLevelSchema>;

export const deleteProfileSkillLevelSchema = z.object({
  instrument: z.string(),
});

export type DeleteProfileSkillLevelSchema = z.infer<typeof deleteProfileSkillLevelSchema>;

export const profileSkillLevelResponse = z.object({
  message: z.string(),
});

export type ProfileSkillLevelResponse = z.infer<typeof profileSkillLevelResponse>;
